<div
  class="container"
  [id]="node.id.toString()"
  [class.active]="activeItemId === node.id && !isEditing"
  [class.read-only]="isReadonly"
  (click)="!isReadonly && setAsActive.emit(node.id); $event.stopPropagation()"
>
  <div class="main-content">
    <div class="left cell" [class.active]="isEditingItemNumber || isEditingTitle">
      <div class="item-number" [class.is-editing]="isEditingItemNumber">
        @if (isEditingItemNumber) {
          <div class="update-container">
            <input
              name="item-number"
              [(ngModel)]="itemNumber"
              (keydown.enter)="saveItemNumber(); isEditingItemNumber = false"
              (keydown.escape)="itemNumber = node.itemNumber; isEditingItemNumber = false; $event.stopPropagation()"
              (blur)="saveItemNumber(); isEditingItemNumber = false"
              cdkTrapFocus
              [cdkTrapFocusAutoCapture]="true"
            />
          </div>
        } @else {
          <div class="field clickable">
            <div class="label" (click)="handleItemNumberLabelClick()">
              @if (node.itemNumber !== null) {
                {{ node.itemNumber }}
              } @else {
                -
              }
            </div>
          </div>
        }
      </div>

      <div class="title">
        @if (isEditingTitle) {
          <div class="update-container">
            <input
              name="title"
              [(ngModel)]="title"
              (keydown.enter)="saveTitle(); isEditingTitle = false"
              (blur)="saveTitle(); isEditingTitle = false"
              (keydown.escape)="title = node.title; isEditingTitle = false; $event.stopPropagation()"
              cdkTrapFocus
              [cdkTrapFocusAutoCapture]="true"
            />
          </div>
        } @else {
          <div class="field clickable">
            <div class="label" (click)="handleTitleLabelClick()">
              @if (node.title === '') {
                -
              } @else {
                {{ node.title }}
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="presenters cell" [class.active]="isEditingPresenters">
      @if (isEditingPresenters) {
        <div class="update-container floating">
          <input
            name="title"
            [(ngModel)]="presenters"
            (keydown.enter)="savePresenters(); isEditingPresenters = false"
            (keydown.escape)="presenters = node.presenters; isEditingPresenters = false; $event.stopPropagation()"
            (blur)="savePresenters(); isEditingPresenters = false"
            cdkTrapFocus
            [cdkTrapFocusAutoCapture]="true"
          />
        </div>
      } @else {
        <div class="field clickable">
          <div class="label" (click)="handlePresentersLabelClick()">
            @if (node.presenters === '') {
              -
            } @else if (!node.presenters.includes(',')) {
              {{ node.presenters }}
            } @else {
              {{ 'COMMON.MULTIPLE' | translate }}
            }
          </div>
        </div>
      }
    </div>
    @if (!isReadonly) {
      <div class="category cell" [class.active]="isEditingCategory">
        @if (isEditingCategory) {
          <div class="update-container">
            <mat-select
              required
              name="category"
              [ngModel]="category"
              (ngModelChange)="saveCategory($event); isEditingCategory = false"
              (closed)="isEditingCategory = false"
              #categoryMatSelect
            >
              <mat-option value="PROCEDURAL">{{ 'CALLS.AGENDA_EDITOR.CATEGORIES.PROCEDURAL' | translate }}</mat-option>
              <mat-option value="SUBSTANTIVE">{{ 'CALLS.AGENDA_EDITOR.CATEGORIES.SUBSTANTIVE' | translate }}</mat-option>
            </mat-select>
          </div>
        } @else if (!hasChildren) {
          <div class="field clickable" (click)="handleCategoryLabelClick()">
            <div class="label">
              {{ 'CALLS.AGENDA_EDITOR.CATEGORIES.' + node.category | translate }}
            </div>
          </div>
        }
      </div>

      <div class="sub-categories cell" [class.active]="isEditingSubCategories">
        @if (isEditingSubCategories) {
          <div class="update-container">
            <mat-select
              required
              name="sub-categories"
              [(ngModel)]="subCategories"
              multiple
              (closed)="saveSubCategories(); isEditingSubCategories = false"
              #subCategoriesMatSelect
            >
              <mat-option value="INTRODUCTION">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.INTRODUCTION' | translate }}</mat-option>
              <mat-option value="CHAIR_OF_THE_MEETING">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.CHAIR_OF_THE_MEETING' | translate }}</mat-option>
              <mat-option value="NOTICE_GIVEN_TO_DIRECTORS">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.NOTICE_GIVEN_TO_DIRECTORS' | translate }}</mat-option>
              <mat-option value="QUORUM">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.QUORUM' | translate }}</mat-option>
              <mat-option value="APOLOGIES_FOR_ABSENCE">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.APOLOGIES_FOR_ABSENCE' | translate }}</mat-option>
              <mat-option value="DECLARATIONS_OF_INTERESTS">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.DECLARATIONS_OF_INTERESTS' | translate }}</mat-option>
              <mat-option value="APPROVAL_OF_PREVIOUS_BOARD_MINUTES"
                >{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.APPROVAL_OF_PREVIOUS_BOARD_MINUTES' | translate }}
              </mat-option>
              <mat-option value="MATTERS_ARISING">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.MATTERS_ARISING' | translate }}</mat-option>
              <mat-option value="ANY_OTHER_BUSINESS">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.ANY_OTHER_BUSINESS' | translate }}</mat-option>
              <mat-option value="DATE_OF_NEXT_MEETING">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.DATE_OF_NEXT_MEETING' | translate }}</mat-option>
              <mat-option value="CLOSE_OF_MEETING">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.CLOSE_OF_MEETING' | translate }}</mat-option>
              <mat-option value="CHAIRS_UPDATE">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.CHAIRS_UPDATE' | translate }}</mat-option>
              <mat-option value="CHAIRS_INTRODUCTION">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.CHAIRS_INTRODUCTION' | translate }}</mat-option>
              <mat-option value="OTHER_PROCEDURAL">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.OTHER_PROCEDURAL' | translate }}</mat-option>
              <mat-option value="VERBAL_UPDATE">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.VERBAL_UPDATE' | translate }}</mat-option>
              <mat-option value="REPORT">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.REPORT' | translate }}</mat-option>
              <mat-option value="DECISIONS_APPROVALS">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.DECISIONS_APPROVALS' | translate }}</mat-option>
              <mat-option value="OTHER_SUBSTANTIVE">{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.OTHER_SUBSTANTIVE' | translate }}</mat-option>
            </mat-select>
          </div>
        } @else {
          <div class="field clickable" (click)="handleSubCategoriesLabelClick()">
            <div class="label">
              @if (node.subCategories.length === 1) {
                {{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.' + node.subCategories[0] | translate }}
              } @else if (node.subCategories.length > 1) {
                {{ 'COMMON.MULTIPLE' | translate }}
              } @else {
                -
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  @for (childNode of node.subitems; track childNode.id) {
    <div class="item">
      <app-agenda-editor-item
        [activeItemId]="activeItemId"
        [isReadonly]="isReadonly"
        [node]="childNode"
        (setAsActive)="setAsActive.emit($event)"
        (updateNode)="updateNode.emit($event)"
      ></app-agenda-editor-item>
    </div>
  }
</div>
